
import React from 'react';
import Common_recharge_page_banner from '../../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';

import Success_Lottie from '../../../../animations/success_lottie/Success_Lottie';
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import FASTag_recharge_plan_card_holder from '../../../../common_components/common_cards/service_rechage_cards/fastag_recharge_cards/FASTag_recharge_plan_card_holder/FASTag_recharge_plan_card_holder';
import Mobile_prepaid_plan_card_holder from '../../../../common_components/common_cards/service_rechage_cards/mobile_Recharge_cards/mobile_prepaid_plan_card_holder/Mobile_prepaid_plan_card_holder';
import Successfull_Modal from '../../../../common_components/common_modal/successfull_modal/Successfull_Modal';
import Contribution from '../../../../home/contribution/Contribution';

function FASTag_recharge_details() {
    const [modalShow, setModalShow] = React.useState(false);
    const breadcrumbData = [
        { label: "Services", path: "/services" },
        { label: "FASTag Recharges", path: "/fastag-recharge" },
        { label: "Kotak Mahindra Bank- Fastag" },

    ];
    return (
        <>
            <section className='Mobile_recharge_view_plans Dth_recharge_details'>
                <Common_recharge_page_banner
                    title="FASTAG RECHARGES"
                    breadcrumbItems={breadcrumbData}
                />

                {/* Left Side - Form */}
                <div className="Mobile_Recharge">
                    <div className="container">
                        <div className="recharge_form_section form_box_section">
                            <div className="row justify-content-center">
                                <div className="col-md-8 col-12">
                                    <Mobile_prepaid_plan_card_holder planName={"Kotak Mahindra Bank- Fastag"} changeLink={"/fastag-recharge"} number={"MH11BH3277"} />

                                    <div className="select_plan_hodler">
                                        <div className="heading_text">
                                            <h6>Details</h6>
                                        </div>

                                        <FASTag_recharge_plan_card_holder />
                                    </div>

                                    <div className="btn_holder ">
                                        <Proceed_btn
                                            btnText="Proceed To Pay"
                                            className="save_changes_btn"
                                            onClick={() => setModalShow(true)}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Contribution />
            </section>
            <Successfull_Modal
                show={modalShow}
                message="FASTag Recharge Successful!"
                subMessage="Your FASTag payment is complete. Payment received, & your tag is now active."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />
        </>
    )
}

export default FASTag_recharge_details